<!-- components/DataTable/DataTable.vue -->
<template>
  <div>
    <!-- Search -->
    <div class="mb-3 w-25">
      <input
        v-model="localSearch"
        @input="handleSearch"
        class="form-control"
        :placeholder="searchPlaceholder"
      />
    </div>

    <!-- Per Page Selector -->
    <div class="mb-3">
      <label>Items per page:</label>
      <select
        v-model="localPerPage"
        @change="handlePerPageChange"
        class="form-control"
        style="width: 120px; display: inline-block;"
      >
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="alert alert-info">Loading...</div>

    <!-- Table Content -->
    <div v-else-if="items.length > 0">
      <!-- ✅ Table Headers -->
      <table class="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th v-for="column in columns" :key="column.key">{{ column.label }}</th>
            <th v-if="actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- ✅ Slot للـ rows -->
          <slot :items="items"></slot>
        </tbody>
      </table>

      <!-- Pagination -->
      <nav aria-label="Page navigation" class="mt-3">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: meta.current_page === 1 }">
            <a class="page-link" href="#" @click.prevent="changePage(meta.current_page - 1)">
              Previous
            </a>
          </li>

          <li
            v-for="page in paginationPages"
            :key="page"
            class="page-item"
            :class="{ active: page === meta.current_page }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">
              {{ page }}
            </a>
          </li>

          <li class="page-item" :class="{ disabled: meta.current_page === meta.last_page }">
            <a class="page-link" href="#" @click.prevent="changePage(meta.current_page + 1)">
              Next
            </a>
          </li>
        </ul>
      </nav>

      <p class="text-center">
        Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} {{ itemName }}
      </p>
    </div>

    <!-- No Data -->
    <div v-else class="alert alert-info">
      No {{ itemName }} found.
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    items: { type: Array, required: true },
    meta: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    searchPlaceholder: { type: String, default: 'Search...' },
    itemName: { type: String, default: 'items' },
    perPage: { type: Number, default: 20 },
    columns: { type: Array, required: true },
    actions: { type: Boolean, default: true },
  },
  data() {
    return {
      localSearch: '',
      localPerPage: this.perPage,
    };
  },
  computed: {
    paginationPages() {
      const pages = [];
      const total = this.meta.last_page || 1;
      const current = this.meta.current_page || 1;
      let start = Math.max(1, current - 2);
      let end = Math.min(total, current + 2);
      if (current <= 3) end = Math.min(5, total);
      if (current >= total - 2) start = Math.max(1, total - 4);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },
  },
  methods: {
    handleSearch() {
      this.$emit('search', this.localSearch);
    },
    handlePerPageChange() {
      this.$emit('per-page-change', this.localPerPage);
    },
    changePage(page) {
      if (page >= 1 && page <= this.meta.last_page) {
        this.$emit('page-change', page);
      }
    },
  },
};
</script>